import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Button, ComponentBase } from '@eventlyte/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
	faCalendar,
	faCircleChevronRight,
	faMapPin,
	faTag
} from '@fortawesome/pro-solid-svg-icons';
import { TranslocoDirective } from '@jsverse/transloco';
import { AppRoutePaths } from '../../app.routes';

@Component({
	selector: 'app-registration-landing-page',
	imports: [FontAwesomeModule, Button, TranslocoDirective],
	templateUrl: './registration-landing-page.html'
})
export class RegistrationLandingPage extends ComponentBase {
	protected icons = { faTag, faCircleChevronRight, faCalendar, faMapPin };
	private router = inject(Router);

	protected navigateToRegistration(): void {
		this.router.navigate([AppRoutePaths.RegistrationInformation]);
	}
}
